import React from 'react';

import { makeStyles } from '@material-ui/core/styles';

import { EditorialSpec } from '../../types/editorial-spec.type';

interface EditorialSpecListProps {
  specs: EditorialSpec[];
}

// Une liste de définition, pas une suite de paragraphes : `<dt>` et `<dd>` disent que la valeur
// appartient au critère, ce que le legacy laissait deviner à des `<br>`.
const useStyles = makeStyles((theme) => ({
  // Un `gap` uniforme séparerait un critère de sa valeur autant que deux couples entre eux, et la
  // paire cesserait de se lire comme une paire. L'écart se pose donc entre les couples seulement.
  list: {
    margin: 0,
    padding: 0,
  },
  term: {
    fontSize: '0.72rem',
    fontWeight: 600,
    letterSpacing: '0.1em',
    textTransform: 'uppercase',
    color: theme.palette.client.primary.main,

    '&:not(:first-of-type)': {
      marginTop: '0.875rem',
    },
  },
  definition: {
    margin: '0.15rem 0 0',
    fontSize: '0.95rem',
    lineHeight: 1.5,
    color: '#3d3d3d',
  },
}));

const EditorialSpecList: React.FC<EditorialSpecListProps> = ({ specs }) => {
  const classes = useStyles();

  return (
    <dl className={classes.list}>
      {specs.map((spec) => (
        // Le couple reste solidaire dans un fragment : intercaler un conteneur entre `<dl>` et ses
        // `<dt>` / `<dd>` romprait la relation que ces balises portent.
        <React.Fragment key={spec.label}>
          <dt className={classes.term}>{spec.label}</dt>
          <dd className={classes.definition}>{spec.value}</dd>
        </React.Fragment>
      ))}
    </dl>
  );
};

export default EditorialSpecList;
